import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { PointsHistory as UIPointsHistory } from "@jti/loyalty/components/PointsHistory";

import type { pointsHistoryInputs } from "./PointsHistory.builder";

type PointsHistoryBuilderProps = BuilderComponentProps<typeof pointsHistoryInputs>;

export const PointsHistory: FC<PointsHistoryBuilderProps> = (props) => {
  return <UIPointsHistory {...props} isInEditor={isEditing()} removeMargin />;
};
